import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'

import { IncidenceRules } from 'modules/bookkeepers/store/collections/incidenceRules'
import type Incidence from 'modules/bookkeepers/store/models/Incidence'

export const useFetchIncidenceRules = (incidence?: Incidence) => {
  const incidenceRules = useLazyRef(() => new IncidenceRules()).current
  const incidenceType = incidence?.attributes?.name
  const companyId = incidence?.attributes?.company_id

  const { loading } = useAsyncData(() => {
    if (incidenceType && companyId) {
      incidenceRules.fetch({
        data: {
          incidence_type: incidenceType,
          company_id: companyId,
        },
      })
    }
    return Promise.resolve()
  }, [incidenceType, companyId])

  return {
    loading,
    incidenceRules,
  }
}
